import React, { useState, useEffect } from 'react';
import './App.css';
import Turn from "./components/Turn";
import Warning from "./components/Warning";
import ReactGA from 'react-ga';
import Api from "./api";

const nosupport = !!navigator.userAgent.match(/Trident.*rv\:11\./);
if (!nosupport) {
  ReactGA.initialize('UA-164484284-1', {
    debug: false,
    titleCase: false,

  });

  ReactGA.pageview('BeyondDreams');


  Api.logData("BeyondDreams", "initload");
}


function App() {

  return (
    <React.Fragment>
      {!nosupport && <Turn />}
      {nosupport && <Warning />}
    </React.Fragment>
  );
}

export default App
